import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-podium-sharp",
  "use": "icon-podium-sharp-usage",
  "viewBox": "0 0 512 512",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" class=\"ionicon\" viewBox=\"0 0 512 512\" id=\"icon-podium-sharp\"><title>Podium</title><path d=\"M160 32h192v448H160zM384 192h112v288H384zM16 128h112v352H16z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol